module.exports = __webpack_public_path__ + "static/img/12.39a472e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/12.png
// module id = dmGE
// module chunks = 0